<template>
  <base-inactivity-timer
    :warning-delay="warningDelay"
    :expire-delay="expireDelay"
    @expire="expire"
    @continue="keepAlive"
    @heart-beat="touchServer"
  />
</template>

<script lang="ts" setup>
import BaseInactivityTimer from '@/common/components/zvdzo/BaseInactivityTimer.vue';
import useLoginData from '@/common/composition/useLoginData';
import { router } from '@/plugins/router';
import useCsrfToken from '@/common/composition/useCsrfToken';

const minuteToMicroseconds = (minutes: string) =>
  parseFloat(minutes.toString()) * 60 * 1000;

const { getLogoutRoute } = useLoginData();

const touchServer = async () => {
  const csrfToken = useCsrfToken();
  await fetch('/api/Login/KeepAlive', {
    method: 'POST',
    headers: { 'X-XSRF-TOKEN': csrfToken },
  });
};

const keepAlive = async () => {
  await touchServer().catch(async e => {
    if (import.meta.env.MODE === 'development') {
      // eslint-disable-next-line no-console
      console.warn(e);
    }
    await router.push(getLogoutRoute());
    throw e;
  });
};

const warningDelay = minuteToMicroseconds(
  import.meta.env.VITE_INACTIVITY_WARNING_MINUTES_DELAY as string,
);
const expireDelay = minuteToMicroseconds(
  import.meta.env.VITE_INACTIVITY_EXPIRE_MINUTES_DELAY as string,
);

const expire = () => {
  router.replace(getLogoutRoute(true));
};
</script>
